import {
  aggregateURL,
  commonURL,
  errorMessage,
  commonBureauURL
} from 'src/constantsMessage/index';
import axios from 'src/utils/axiosHelper';
import { SET_ALERT } from 'src/actions/alertAction';
import helperAxios from 'src/utils/helperAxios';

export const GET_AGGREGATE_OVERVIEW = '@aggregateAnalysis/get-overview';
export const GET_AGGREGATE_OVERVIEW_ERROR =
  '@aggregateAnalysis/get-overview-error';
export const GET_AGGREGATE_OVERVIEW_EMPTY =
  '@aggregateAnalysis/get-overview-empty';
export const GET_AGGREGATE_ACCOUNT_TABSCOUNT =
  '@aggregateAnalysis/get-tabscount';
export const GET_AGGREGATE_ACCOUNT_TABSCOUNT_ERROR =
  '@aggregateAnalysis/get-tabscount-error';
export const GET_SUSPICIOUS_ACTIVITY =
  '@aggregateAnalysis/get-suspicious_activity';
export const GET_SUSPICIOUS_ACTIVITY_ERROR =
  '@aggregateAnalysis/get-suspicious_activity_error';
export const GET_SUSPICIOUS_ACTIVITY_EMPTY =
  '@aggregateAnalysis/get-suspicious_activity_empty';
export const GET_CIRCULAR_TRANSACTIONS =
  '@aggregateAnalysis/get-circulat-transactions';
export const GET_CIRCULAR_TRANSACTIONS_ERROR =
  '@aggregateAnalysis/get-circulat-transactions-error';
export const GET_CIRCULAR_TRANSACTIONS_EMPTY =
  '@aggregateAnalysis/get-circulat-transactions-empty';
export const GET_INTRA_BANK_FUND_TRANSFER =
  '@aggregateAnalysis/get-intra-bank-fund-transfer';
export const GET_INTRA_BANK_FUND_TRANSFER_ERROR =
  '@aggregateAnalysis/get-intra_bank-fund-transfer-error';
export const GET_INTRA_BANK_FUND_TRANSFER_EMPTY =
  '@aggregateAnalysis/get-intra-bank-fund-transfer-empty';
export const GET_BOUNCED_CHEQUE = '@aggregateAnalysis/get-bounced-cheque';
export const GET_BOUNCED_CHEQUE_ERROR =
  '@aggregateAnalysis/get-bounced-cheque-error';
export const GET_BOUNCED_CHEQUE_EMPTY =
  '@aggregateAnalysis/get-bounced-cheque-empty';
export const GET_CASH_FLOW = '@aggregateAnalysis/get-cashFlow';
export const GET_CASH_FLOW_ERROR = '@aggregateAnalysis/get-cashFlow-error';
export const GET_CASH_FLOW_EMPTY = '@aggregateAnalysis/get-cashFlow-empty';
export const GET_BIZ_CASHFLOW = '@aggregateAnalysis/biz-cash-flow';
export const GET_BIZ_CASHFLOW_ERROR = '@aggregateAnalysis/biz-cash-flow-error';
export const GET_BIZ_CASHFLOW_EMPTY = '@aggregateAnalysis/biz-cash-flow-empty';
export const GET_COUNTER_PARTY = '@aggregateAnalysis/biz-counter-party';
export const GET_COUNTER_PARTY_ERROR =
  '@aggregateAnalysis/biz-counter-party-error';
export const GET_COUNTER_PARTY_EMPTY =
  '@aggregateAnalysis/biz-counter-party-empty';
export const GET_ODCC_UTILIZATION = '@aggregateAnalysis/od-cc-utilization';
export const GET_ODCC_UTILIZATION_ERROR =
  '@aggregateAnalysis/od-cc-utilization-error';
export const GET_ODCC_UTILIZATION_EMPTY =
  '@aggregateAnalysis/od-cc-utilization-empty';
export const GET_RECURRING_PAYMENTS =
  '@aggregateAnalysis/get-recurring-payments';
export const GET_RECURRING_PAYMENTS_ERROR =
  '@aggregateAnalysis/get-recurring-payments-error';
export const GET_RECURRING_PAYMENTS_EMPTY =
  '@aggregateAnalysis/get-recurring-payments-empty';
export const GET_RECURRING_DEPOSITS =
  '@aggregateAnalysis/get-recurring-deposits';
export const GET_RECURRING_DEPOSITS_ERROR =
  '@aggregateAnalysis/get-recurring-deposits-error';
export const GET_RECURRING_DEPOSITS_EMPTY =
  '@aggregateAnalysis/get-recurring-deposits-empty';
export const GET_EMI_DEPOSITS = '@aggregateAnalysis/get-emi-deposits';
export const GET_EMI_DEPOSITS_ERROR = '@aggregateAnalysis/get-emi-error';
export const GET_EMI_DEPOSITS_EMPTY = '@aggregateAnalysis/get-emi-empty';
export const GET_LOANS = '@aggregateAnalysis/get-loans';
export const GET_LOANS_ERROR = '@aggregateAnalysis/get-loans-error';
export const GET_LOANS_EMPTY = '@aggregateAnalysis/get-loans-empty';
export const GET_SALARY = '@aggregateAnalysis/get-salary';
export const GET_SALARY_ERROR = '@aggregateAnalysis/get-salary-error';
export const GET_SALARY_EMPTY = '@aggregateAnalysis/get-salary-empty';
export const GET_CATEGORIES = '@aggregateAnalysis/get-categories';
export const GET_CATEGORIES_ERROR = '@aggregateAnalysis/get-categories-error';
export const GET_CATEGORIES_EMPTY = '@aggregateAnalysis/get-categories-empty';
export const LOADER = '@aggregateAnalysis/loader';
export const EMPTY_AGGREGATE_ANALYSIS = '@aggregateAnalysis/emptyAll';
export const GET_COUNTER_PARTY_MONTHLY = '@aggregate/counter-party-monthly';
export const GET_COUNTER_PARTY_MONTHLY_ERROR =
  '@aggregate/counter-party-monthly-error';
export const GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION =
  '@aggregate/counter-party-monthly-with-pagination';
export const AG_FOR_RE_ANALYSIS = '@aggregate/ReAnalysisForMonthlyCounterparty';
export const AG_TAB_PERSIST = '@aggregate/ag-tab-persist';
export const GET_DAILY_BALANCE = '@aggregate/get-DAILY_BALANCE';
export const GET_DAILY_BALANCE_ERROR = '@aggregate/get-DAILY_BALANCE-error';
export const GET_DAILY_BALANCE_EMPTY = '@aggregate/get-DAILY_BALANCE-empty';
export const GET_SUMMARY = '@aggregate/get-summary';
export const GET_SUMMARY_ERROR = '@aggregate/get-summary-error';
export const GET_SUMMARY_EMPTY = '@aggregate/get-summary-empty';
export const GET_LOAN_ANALYSIS = '@aggregateAnalysis/get-loanAnalysis';
export const GET_LOAN_ANALYSIS_ERROR =
  '@aggregateAnalysis/get-loanAnalysis-error';
export const GET_LOAN_ANALYSIS_EMPTY =
  '@aggregateAnalysis/get-loanAnalysis-empty';
export const GET_AGGREGATE_BUREAU = '@aggregate/get-aggregate-bureau';
export const GET_AGGREGATE_BUREAU_ERROR =
  '@aggregate/get-aggregate-bureau-error';
export const GET_AGGREGATE_BUREAU_EMPTY =
  '@aggregate/get-aggregate-bureau-empty';
export const GET_UPI_TXNS = '@aggregateAnalysis/get-upiTxnsAnalysis';
export const GET_UPI_TXNS_ERROR =
  '@aggregateAnalysis/get-upiTxnsAnalysis-error';
export const GET_UPI_TXNS_EMPTY =
  '@aggregateAnalysis/get-upiTxnsAnalysis-empty';

export function emptyAggregateAnalysis() {
  return dispatch => {
    dispatch({
      type: EMPTY_AGGREGATE_ANALYSIS
    });
  };
}

export function getAggregateOverview(refId) {
  const url = `${aggregateURL}/summary?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_OVERVIEW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_OVERVIEW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAggregateOverview() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_OVERVIEW_EMPTY
    });
  };
}

export function getAggregateTabCounts(refId) {
  const url = `${aggregateURL}/tabs?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_ACCOUNT_TABSCOUNT,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_ACCOUNT_TABSCOUNT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getAgSuspiciousActivity(refId) {
  const url = `${aggregateURL}/irregularities?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SUSPICIOUS_ACTIVITY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SUSPICIOUS_ACTIVITY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgSuspiciousActivity() {
  return dispatch => {
    dispatch({
      type: GET_SUSPICIOUS_ACTIVITY_EMPTY
    });
  };
}

export function getAgCircularTxn(refId) {
  const url = `${aggregateURL}/circularTransactions?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CIRCULAR_TRANSACTIONS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CIRCULAR_TRANSACTIONS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getAgIntraBankFundTransfer(refId) {
  const url = `${aggregateURL}/intraBankFundTransfer?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_INTRA_BANK_FUND_TRANSFER,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_INTRA_BANK_FUND_TRANSFER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgIntraBankFundTransfer() {
  return dispatch => {
    dispatch({
      type: GET_INTRA_BANK_FUND_TRANSFER_EMPTY
    });
  };
}

export function emptyAgCircularTxn() {
  return dispatch => {
    dispatch({
      type: GET_CIRCULAR_TRANSACTIONS_EMPTY
    });
  };
}

export function getAgBouncedCheques(refId) {
  const url = `${aggregateURL}/bouncedCheque?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_BOUNCED_CHEQUE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_BOUNCED_CHEQUE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgBouncedCheques() {
  return dispatch => {
    dispatch({
      type: GET_BOUNCED_CHEQUE_EMPTY
    });
  };
}

export function getAgCashFlow(refId) {
  const url = `${aggregateURL}/cashflow?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CASH_FLOW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CASH_FLOW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getAgUpiTxnsAnalysis(refId) {
  const url = `${aggregateURL}/UPIAnalysis?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_UPI_TXNS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_UPI_TXNS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getAgLoanAnalysis(refId) {
  const url = `${aggregateURL}/loanAnalysis?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_LOAN_ANALYSIS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_LOAN_ANALYSIS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgCashFlow() {
  return dispatch => {
    dispatch({
      type: GET_CASH_FLOW_EMPTY
    });
  };
}

export function getAgBizCashFlow(refId) {
  const url = `${aggregateURL}/businessCashFlow?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_BIZ_CASHFLOW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_BIZ_CASHFLOW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgBizCashFlow() {
  return dispatch => {
    dispatch({
      type: GET_BIZ_CASHFLOW_EMPTY
    });
  };
}

export function getAgCounterparty(refId) {
  const url = `${aggregateURL}/counterparty?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_COUNTER_PARTY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_COUNTER_PARTY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgCounterparty() {
  return dispatch => {
    dispatch({
      type: GET_COUNTER_PARTY_EMPTY
    });
  };
}

export function getAgODCCUtilization(refId) {
  const url = `${aggregateURL}/utilization?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_ODCC_UTILIZATION,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_ODCC_UTILIZATION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgODCCUtilization() {
  return dispatch => {
    dispatch({
      type: GET_ODCC_UTILIZATION_EMPTY
    });
  };
}

export function getAgRecurringPayments(refId) {
  const url = `${aggregateURL}/patterns?reportReferenceId=${refId}&type=recurringPayments`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_RECURRING_PAYMENTS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_RECURRING_PAYMENTS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgRecurringPayments() {
  return dispatch => {
    dispatch({
      type: GET_RECURRING_PAYMENTS_EMPTY
    });
  };
}

export function getAgRecurringDeposits(refId) {
  const url = `${aggregateURL}/patterns?reportReferenceId=${refId}&type=recurringDeposits`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_RECURRING_DEPOSITS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_RECURRING_DEPOSITS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgRecurringDeposits() {
  return dispatch => {
    dispatch({
      type: GET_RECURRING_DEPOSITS_EMPTY
    });
  };
}

export function getAgEmiPayments(refId) {
  const url = `${aggregateURL}/patterns?reportReferenceId=${refId}&type=emi`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_EMI_DEPOSITS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_EMI_DEPOSITS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgEmiPayments() {
  return dispatch => {
    dispatch({
      type: GET_EMI_DEPOSITS_EMPTY
    });
  };
}

export function getAgLoans(refId) {
  const url = `${aggregateURL}/patterns?reportReferenceId=${refId}&type=loans`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_LOANS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_LOANS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgLoans() {
  return dispatch => {
    dispatch({
      type: GET_LOANS_EMPTY
    });
  };
}

export function getAgSalary(refId) {
  const url = `${aggregateURL}/patterns?reportReferenceId=${refId}&type=salary`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgSalary() {
  return dispatch => {
    dispatch({
      type: GET_SALARY_EMPTY
    });
  };
}

export function getAgCategories(refId) {
  const url = `${aggregateURL}/categories?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CATEGORIES,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CATEGORIES_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgCategories() {
  return dispatch => {
    dispatch({
      type: GET_CATEGORIES_EMPTY
    });
  };
}

export function getAgMonthlyCounterparty(refId) {
  const url = `${aggregateURL}/monthlyCounterparty?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        if (response.data.isReanalysisRequired) {
          dispatch({
            type: AG_FOR_RE_ANALYSIS,
            payload: true
          });
          dispatch({
            type: SET_ALERT,
            payload: errorMessage.reAnalysisMessage,
            payload1: 'error'
          });
        } else {
          dispatch({
            type: GET_COUNTER_PARTY_MONTHLY,
            payload: response.data
          });
        }
      })
      .catch(error => {
        dispatch({
          type: GET_COUNTER_PARTY_MONTHLY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getagMonthlyCounterPartyWithPagination(
  monthlyData,
  pagination
) {
  const url = `${commonURL}/customAnalysisFilters?page=${
    pagination.page
  }&size=${pagination.rowsPerPage}&order=${
    pagination.orderBy === '' ? '' : pagination.order
  }&sortBy=${pagination.orderBy}&search=${pagination.query}&showOnly=${
    pagination.txnsType
  }&for=mnthlycpt`;
  const request = helperAxios(url, 'post', monthlyData);
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_COUNTER_PARTY_MONTHLY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function setAgTabPersist(tabName) {
  return dispatch => {
    dispatch({
      type: AG_TAB_PERSIST,
      payload: tabName
    });
  };
}

export function getAgDailyBalance(refId) {
  const url = `${aggregateURL}/dailyBalance?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: GET_DAILY_BALANCE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_DAILY_BALANCE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgDailyBalance() {
  return dispatch => {
    dispatch({
      type: GET_DAILY_BALANCE_EMPTY
    });
  };
}

export function getAgSummary(refId) {
  const url = `${aggregateURL}/customAnalysis?reportReferenceId=${refId}&portal=1`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    // dispatch({
    //   type: LOADER
    // });
    request
      .then(response =>
        dispatch({
          type: GET_SUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SUMMARY_ERROR,
          payload: error.response && error.response.data
        });
      });
  };
}

export function emptyAgSummary() {
  return dispatch => {
    dispatch({
      type: GET_SUMMARY_EMPTY
    });
  };
}

export function getAgBureau(refId, type) {
  const url = `${commonBureauURL}/aggregate?reportReferenceId=${refId}&type=${type}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: GET_AGGREGATE_BUREAU,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AGGREGATE_BUREAU_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgBureau() {
  return dispatch => {
    dispatch({
      type: GET_AGGREGATE_BUREAU_EMPTY
    });
  };
}
